'use client';

import React from 'react';
import { Container, Text, Group } from '@mantine/core';
import { useLanguage } from '@/context/LanguageContext';
import { useCheckoutConfig } from '@/lib/hooks';

export const FreeShippingBanner: React.FC = () => {
  const { t } = useLanguage();
  const { data: config } = useCheckoutConfig();
  
  // Format the free shipping threshold for display
  const threshold = config?.freeShippingThreshold;
  const freeShippingText = threshold 
    ? `${t('banner.freeShippingPrefix') || 'Wysyłka od'} ${threshold}${t('banner.freeShippingSuffix') || 'zł GRATIS'}`
    : t('banner.freeShipping');

  return (
    <div
      style={{
        backgroundColor: '#000000',
        color: '#ffffff',
        padding: '0.75rem 0',
        textAlign: 'center',
        fontSize: '0.875rem',
        fontWeight: 500,
        borderBottom: '1px solid #333',
      }}
    >
      <Container size="xl">
        <Group justify="center" gap="md">
          <Text size="sm" fw={500} c="white">
            {freeShippingText}
          </Text>
          <Text size="sm" c="gray" style={{ opacity: 0.7 }}>
            •
          </Text>
          <Text size="sm" fw={500} c="white">
            {t('banner.guarantee')}
          </Text>
        </Group>
      </Container>
    </div>
  );
};

